import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import useTheme from "@mui/material/styles/useTheme";
import { logout } from "../Core/Session";

const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
    padding: theme.spacing(3),
    paddingBottom: theme.spacing(1),
    "& h1": {
        fontSize: "1.75rem",
        fontWeight: 700,
        margin: 0,
    },
}));

const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
    padding: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
}));

const BackToLoginButton = styled(Button)(({ theme }) => ({
    backgroundColor: 'black',
    color: "white",
    padding: theme.spacing(1.5),
    marginTop: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    textTransform: "none",
    "&:hover": {
        backgroundColor: "#333333",
    },
}));

interface SessionExpiredModalProps {
    open: boolean;
}

export function SessionExpiredModal({ open }: SessionExpiredModalProps): React.JSX.Element {
    const theme = useTheme();

    const handleBackToLogin = async () => {
        await logout();
    };

    return (
        <Dialog
            open={open}
            aria-labelledby="session-expired-dialog-title"
            maxWidth="sm"
            fullWidth
            disableEscapeKeyDown
            slotProps={{
                paper: {
                    sx: {
                        borderRadius: 1,
                        boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06)",
                        maxWidth: "400px",
                        zIndex: theme.zIndex.drawer + 2,
                    },
                },
                backdrop: {
                    sx: { 
                        backgroundImage: `url(${theme.backgroundImage})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                    },
                },
            }}
        >
            <StyledDialogTitle id="session-expired-dialog-title">
                <Typography variant="h1">Session Expired</Typography>
            </StyledDialogTitle>
            <StyledDialogContent dividers={false}>
                <Typography variant="body1" color="text.secondary">
                    Your session has expired due to inactivity. Please log in again to continue.
                </Typography>
                <BackToLoginButton fullWidth variant="contained" onClick={handleBackToLogin}>
                    Back to Login
                </BackToLoginButton>
            </StyledDialogContent>
        </Dialog>
    );
}